function parseExperiments(wixExperiments) {
  return Object.entries(wixExperiments).reduce((parsed, [key, value]) => {
    const [, namespace, name] = key.split(".");
    const _value = value.toString().toLowerCase();
    parsed[name] = {
      enabled: _value !== "" && _value !== "false",
      value,
      namespace
    };
    return parsed;
  }, {});
}

export { parseExperiments };
